import { render, staticRenderFns } from "./BtnSubmit.vue?vue&type=template&id=c774238a&scoped=true&"
import script from "./BtnSubmit.vue?vue&type=script&lang=js&"
export * from "./BtnSubmit.vue?vue&type=script&lang=js&"
import style0 from "./BtnSubmit.vue?vue&type=style&index=0&id=c774238a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c774238a",
  null
  
)

export default component.exports